var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content-container"},[_c('input',{attrs:{"type":"file"},on:{"change":_vm.upload}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"mt-4"},[_c('a',{attrs:{"href":"/scraper/"}},[_vm._v("Search objekt")]),_vm._v(" / Ladda upp\n    ")])
}]

export { render, staticRenderFns }